import React, { useEffect } from 'react'
import Router, { useRouter } from 'next/router'
import WebsiteHeader from 'WebsiteHeader'
import WebsiteFooter from 'WebsiteFooter'
import { SchemaMarkupLocalWebsite } from '../utility/SchemaMarkupLocalWebsite'
import { Fab } from '../base-ui'

export function Layout({ children, pageProps }) {
    const { locale } = useRouter()
    useEffect(() => {
        if (pageProps.redirect) Router.push(pageProps.redirect.destination)
    }, [pageProps?.redirect])

    if (pageProps.redirect) return null

    return (
        <div
            css={(theme) => ({
                color: theme.colors?.text,
                fontFamily:
                    theme?.font[locale]?.main ?? theme?.font['default']?.main,
                backgroundColor: theme.colors.mainBackground,
                direction: ['ar', 'fa'].indexOf(locale) !== -1 ? 'rtl' : 'ltr',
            })}
            className={['ar', 'fa'].indexOf(locale) !== -1 ? '' : 'ltr'}
        >
            <WebsiteHeader />
            <Fab />
            <div>{children}</div>
            <SchemaMarkupLocalWebsite />
            <WebsiteFooter />
        </div>
    )
}
